import ContactComponent from '@components/Contact/ContactComponent.vue';
import { Vue } from '@master';

const contactPage = new Vue({
    el: '#contact_page',
    title: "Contact Us",
    mounted() {
        this.gaPageView(`/contact`, 'Contact Us');
    },
    components: {
        'contact-form': ContactComponent
    }
});
